export enum DataClientError {
    GraphqlFetchRemoteSchemaFailed = "Failed to fetch remote GraphQL schema",
    GraphqlLocalSchemaFailed = "Failed to make local GraphQL schema",
    GraphqlSchemaStitchingFailed = "Failed to stitch GraphQL schemas",
    GraphqlApolloClientInitializationFailed = "Failed to initialize Apollo Client"
}
